module.exports = __webpack_public_path__ + "static/img/any.a9f4f78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/center/any.jpg
// module id = fGVN
// module chunks = 80